import React from 'react';

import {
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import styled from 'styled-components';
import { SpacingV } from 'view/pages/InstructorApp/component/common/Spacing';
import Redirect from 'view/pages/InstructorApp/component/tab/Redirect';
import Step1 from 'view/pages/InstructorApp/component/tab/Step1';
import Step2 from 'view/pages/InstructorApp/component/tab/Step2';
import Step3 from 'view/pages/InstructorApp/component/tab/Step3';

const routes = {
    step1: {
        component: <Step1 />,
        path: "step1",
        indicate: "Step 1",
    },
    step2: {
        component: <Step2 />,
        path: "step2",
        indicate: "Step 2",
    },
    step3: {
        component: <Step3 />,
        path: "step3",
        indicate: "Step 3",
    },
};

const InstructorApp = () => {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    console.log("params", params);

    const StepComponents = () => {
        switch (params?.step) {
            case routes.step1.path: {
                return routes.step1.component;
            }
            case routes.step2.path: {
                return routes.step2.component;
            }
            case routes.step3.path: {
                return routes.step3.component;
            }
            default: {
                return <Redirect />;
            }
        }
    };

    return (
        <Container>
            <ContentsInner>
                <Title>Instructor Application</Title>
                {StepComponents()}
                <SpacingV height={65} />
                <StepContainer>
                    {Object.values(routes)?.map((item) => {
                        return (
                            <Step>
                                <StepTitle className={item?.path === params?.step ? "on" : ""}>
                                    <span>{item?.indicate}</span>
                                </StepTitle>
                                <StepIndication
                                    className={item?.path === params?.step ? "on" : ""}
                                />
                            </Step>
                        );
                    })}
                </StepContainer>
            </ContentsInner>
        </Container>
    );
};
export default InstructorApp;

const Title = styled.h1`
    margin-bottom: 55px;
    font-size: 27px;
    line-height: 35px;
    font-weight: 700;
    color: #333;
`;
const Container = styled.div`
    background: #fff;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 30px;
    transition: all 0.3s;
    @media screen and (max-width: 768px) {
        padding-top: 0;
        align-items: flex-start;
    }
`;
const ContentsInner = styled.div`
    padding: 30px 56px 65px;
    max-width: 700px;
    width: 100%;
    background: #fff;
    transition: all 0.3s;
    -webkit-box-shadow: 0 0 18px 9px rgba(0, 0, 0, 0.06);
    box-shadow: 0 0 18px 9px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    max-height: calc(100vh - 90px);
    overflow-y: scroll;
    scrollbar-widt    scrollbar-color: #33333320 transparent;
    h: thin;
    scroll-behavior: smooth;
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
`;
const StepContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;
const Step = styled.div`
    width: calc((100% - 20px) / 3);
`;
const StepTitle = styled.div`
    span {
        font-size: 16px;
        line-height: 21px;
        color: #666;
        .on& {
            color: #e0c463;
        }
    }
`;
const StepIndication = styled.div`
    margin-top: 7px;
    height: 7px;
    border-radius: 100px;
    background: #e9e9e9;
    &.on {
        background: #e0c463;
    }
`;
